import { Controller } from "@hotwired/stimulus"

const AUTOHIDE_DELAY = 8000

export default class extends Controller {
  static values = { autohide: { type: Boolean, default: true } }

  connect() {
    if (!this.autohideValue) return
    this.timer = setTimeout(() => this.dismiss(), AUTOHIDE_DELAY)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  dismiss() {
    this.element.remove()
  }
}
